module.exports = __webpack_public_path__ + "img/sidebar_rlwest_202627.c38f8a40.png";